"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Timer_1 = tslib_1.__importDefault(require("../core/Timer"));
const Widget_1 = tslib_1.__importDefault(require("../core/Widget"));
const DOM_1 = tslib_1.__importDefault(require("../util/DOM"));
const HTMLUtils_1 = tslib_1.__importDefault(require("../util/HTMLUtils"));
class Tip {
    constructor(element, tip, tipProvider, tipPromise) {
        this.element = element;
        this.tip = tip;
        this.tipProvider = tipProvider;
        this.tipPromise = tipPromise;
    }
    register() {
        this.listener = () => this.showToolTip();
        this.element.addEventListener("mouseover", this.listener);
        ["mouseout", "click", "scroll"].forEach(event => {
            this.element.addEventListener(event, () => this.hideToolTip());
        });
    }
    unregister() {
        if (this.listener) {
            this.element.removeEventListener("mouseover", this.listener);
            this.listener = undefined;
        }
    }
    showToolTip() {
        this.showing = true;
        this.fadeInTimer = new Timer_1.default(this.doShowToolTip.bind(this));
        this.fadeInTimer.schedule(600);
    }
    doShowToolTip() {
        if (!this.showing) {
            return;
        }
        if (this.fadeInTimer) {
            this.fadeInTimer = undefined;
        }
        if (!this.toolTipDiv) {
            this.toolTipDiv = DOM_1.default.createDiv();
            this.toolTipDiv.className = "tt-sliding-door";
            const divLowerLeft = DOM_1.default.createDiv();
            divLowerLeft.className = "tt-sliding-door-corner-ur";
            const divUpperRight = DOM_1.default.createDiv();
            divUpperRight.className = "tt-sliding-door-corner-ll";
            this.contentElement = DOM_1.default.createSpan();
            this.toolTipDiv.appendChild(this.contentElement);
            this.toolTipDiv.appendChild(divUpperRight);
            this.toolTipDiv.appendChild(divLowerLeft);
            document.body.appendChild(this.toolTipDiv);
            this.setToolTipText();
            const elementBounds = this.element.getBoundingClientRect();
            let left = elementBounds.left;
            const overflowX = left + Tip.MAX_WIDTH - (this.scroll.left + this.scroll.width);
            if (overflowX > 0) {
                left -= overflowX;
            }
            let top;
            if (!this.isElementVisible(elementBounds, this.toolTipDiv.clientHeight)) {
                top = elementBounds.bottom - this.toolTipDiv.clientHeight - 20;
            }
            else {
                top = elementBounds.bottom + 15;
            }
            this.toolTipDiv.style.top = `${top}px`;
            this.toolTipDiv.style.left = `${left}px`;
            this.toolTipDiv.style.opacity = "1";
            this.fadeOutTimer = new Timer_1.default(this.hideToolTip.bind(this));
            this.fadeOutTimer.schedule(30000);
        }
        this.setToolTipText();
    }
    hideToolTip() {
        this.showing = false;
        if (this.fadeInTimer) {
            this.fadeInTimer.cancel();
            this.fadeInTimer = undefined;
        }
        if (this.fadeOutTimer) {
            this.fadeOutTimer.cancel();
            this.fadeOutTimer = undefined;
        }
        if (this.scrollHandlerRegistration) {
            this.scrollHandlerRegistration.removeHandler();
            this.scrollHandlerRegistration = undefined;
        }
        if (this.toolTipDiv) {
            this.toolTipDiv.remove();
            this.toolTipDiv = undefined;
        }
    }
    setToolTipText() {
        if (this.tipPromise) {
            this.tipPromise().then(tip => {
                HTMLUtils_1.default.setSanitizedHTML(this.contentElement, tip);
            });
        }
        else if (this.tipProvider) {
            HTMLUtils_1.default.setSanitizedHTML(this.contentElement, this.tipProvider());
        }
        else {
            HTMLUtils_1.default.setSanitizedHTML(this.contentElement, this.tip);
        }
    }
    /**
     * Retrieves the x, y width and height properties of the visible scroll port (rectangle of the browser)
     */
    get scroll() {
        const supportPageOffset = window.pageXOffset !== undefined;
        const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
        const left = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        const top = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        return { left, top, width, height };
    }
    isElementVisible(rect, clientHeight) {
        return rect.bottom > 0 &&
            rect.right > 0 &&
            rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
            (rect.top + clientHeight) * 1.05 < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
    }
}
// Assuming tooltips are at most 278 pixels wide - this is controlled by stylesheet
Tip.MAX_WIDTH = 278;
class SlidingDoorTooltip {
    add(target, tip, tipProvider, tipPromise) {
        const element = target instanceof Widget_1.default ? target.element : target;
        if (element) {
            this.tip = new Tip(element, tip, tipProvider, tipPromise);
            this.tip.register();
        }
        else {
            throw new Error("Unsupported");
        }
    }
    remove(target) {
        const element = target instanceof Widget_1.default ? target.element : target;
        if (element && this.tip && this.tip.element === element) {
            this.tip.unregister();
        }
        else {
            throw new Error("Unsupported");
        }
    }
}
exports.default = SlidingDoorTooltip;
//# sourceMappingURL=SlidingDoorTooltip.js.map